export const settings = {
      title: 'Configuración',
      subtitle: 'Parámetros generales del sistema',
      security: 'Seguridad y accesos',
      securityDescription:
        'Administra usuarios, niveles de acceso y control operativo.',
      manageUsers: 'Gestionar usuarios',
      financialSettings: 'Configuración financiera',
      financialSettingsDescription:
        'Administra la paridad operativa utilizada entre pesos mexicanos y dólares.',
      basicCatalogs: 'Catálogos básicos',
      basicCatalogsDescription:
        'Administra almacenes, categorías, unidades, tipos de empaque y tipos de movimiento.',
      commercialCatalogs: 'Catálogos comerciales',
      commercialCatalogsDescription:
        'Centraliza la información base de tipos de cliente, proveedores y clientes.',
      customerTypesTitle: 'Tipos de cliente',
      customerTypesDescription: 'Clasifica clientes por perfil comercial y relación de negocio.',
      previewLabel: 'Acción',
      back: 'Volver a configuración',
      open: 'Abrir',
      catalogRecordsTitle: 'Registros de {{catalog}}',
      catalogRecordsDescription: 'Catálogo para administrar {{catalog}}.',
      catalogCreateTitle: 'Agregar {{catalog}}',
      catalogEditTitle: 'Editar {{catalog}}',
      catalogDeleteTitle: 'Eliminar {{catalog}}',
      catalogCreateSubtitle: 'Captura los datos principales de {{catalog}}.',
      catalogEditSubtitle: 'Actualiza los datos principales de {{catalog}}.',
      catalogDeleteSubtitle: 'Esta acción eliminará {{catalog}} {{name}}.',
      catalogDeleteSubtitleFallback: 'Esta acción eliminará el registro seleccionado.',
      catalogEmptyTitle: 'Sin registros en este catálogo',
      catalogEmptyDescription: 'No hay elementos disponibles para {{catalog}}.',
      catalogNotFoundTitle: 'Catálogo no encontrado',
      catalogNotFoundDescription: 'No existe una definición disponible para el catálogo solicitado.',
      warehousesTitle: 'Almacenes',
      warehousesDescription: 'Define almacenes y puntos operativos para el control de inventario.',
      addWarehouse: 'Agregar almacén',
      editWarehouse: 'Editar almacén',
      deleteWarehouseTitle: 'Eliminar almacén',
      deleteWarehouseSubtitle: 'Esta acción eliminará el almacén {{name}}.',
      deleteWarehouseSubtitleFallback: 'Esta acción eliminará el almacén seleccionado.',
      warehouseModalTitle: 'Agregar almacén',
      warehouseModalSubtitle: 'Captura los datos operativos del almacén.',
      warehouseEditSubtitle: 'Actualiza los datos operativos del almacén.',
      categorySingular: 'categoría',
      unitSingular: 'unidad',
      customerTypeSingular: 'tipo de cliente',
      movementTypeSingular: 'tipo de movimiento',
      packagingTypeSingular: 'tipo de empaque',
      providerSingular: 'proveedor',
      clientSingular: 'cliente',
      categoriesTitle: 'Categorías',
      categoriesDescription: 'Clasifica productos por grupo o familia.',
      unitsTitle: 'Unidades de medida',
      unitsDescription: 'Define unidades operativas para inventario, insumos y comercialización.',
      packagingTypesTitle: 'Tipos de empaque',
      packagingTypesDescription: 'Define tipos de empaque comerciales como cajas y palets con su equivalencia directa en piezas.',
      exchangeRateTitle: 'Tipo de cambio',
      exchangeRateDescription: 'Administra la paridad operativa entre MXN y USD.',
      exchangeRateListDescription: 'Actualiza la paridad MXN/USD que utiliza el sistema.',
      exchangeRateCardTitle: 'Paridad MXN/USD',
      exchangeRateCardDescription: 'Configura los tipos de cambio de compra y venta vigentes para operación y reportes.',
      exchangeRateHistoryTitle: 'Histórico de tipos de cambio',
      exchangeRateHistoryDescription: 'Consulta las paridades registradas previamente para MXN/USD.',
      exchangeRateRecordedAtLabel: 'Registrado el',
      exchangeRateBuyLabel: 'Tipo de cambio compra',
      exchangeRateBuyHint: 'Valor de compra en pesos mexicanos por un dólar estadounidense.',
      exchangeRateSellLabel: 'Tipo de cambio venta',
      exchangeRateSellHint: 'Valor de venta en pesos mexicanos por un dólar estadounidense.',
      exchangeRateEffectiveDateLabel: 'Fecha de vigencia',
      exchangeRateEffectiveDateHint: 'Captura la fecha de vigencia en formato de negocio. Puede ser actual, futura o retroactiva.',
      exchangeRateEffectiveDateValidation: 'Ingresa una fecha de vigencia valida.',
      exchangeRateValidation: 'Ingresa tipos de cambio mayores a cero.',
      exchangeRateSellGreaterOrEqualValidation: 'El tipo de cambio de venta debe ser mayor o igual al tipo de cambio de compra.',
      exchangeRateSaveHelp: 'Guardar registra una nueva vigencia y conserva el historico, incluido el registro actual.',
      exchangeRateConfirmTitle: 'Confirmar tipo de cambio',
      exchangeRateConfirmSubtitle: 'Revisa los valores antes de guardar la nueva vigencia.',
      exchangeRateFinalConfirmTitle: 'Confirmacion final',
      exchangeRateFinalConfirmSubtitle: 'Esta accion registrara la nueva vigencia.',
      exchangeRateFinalConfirmQuestion: 'Esta seguro?',
      exchangeRateFinalConfirmAction: 'Guardar',
      saveExchangeRate: 'Guardar tipos de cambio',
      baseCurrencyLabel: 'Moneda base',
      quoteCurrencyLabel: 'Moneda secundaria',
      lastUpdatedLabel: 'Última actualización',
      movementTypesTitle: 'Tipos de movimiento',
      movementTypesDescription: 'Define motivos de entrada y salida para registrar inventario.',
      providersTitle: 'Proveedores',
      providersDescription: 'Administra datos de contacto y relación comercial de proveedores.',
      clientsTitle: 'Clientes',
      clientsDescription: 'Administra clientes frecuentes para pedidos y seguimiento comercial.',
    } as const;
